import "./SectionHighlight.scss";

export default {
  root: "im-section-highlight",
  info: "im-section-highlight--info",
  discrete: "im-section-highlight--discrete",
};
